// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Legacy 2015 Styles
| If possible, migrate to classes defined in non-legacy css files.
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
div.ezClockerHeader2015 {
  z-index: 9999;
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
  width: 100%;
  top: -2px;
  left: -2px;
  padding-left: 4px;
  padding-right: 4px;
  position: fixed;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
}

div.ezClockerHeader2015NonFixed {
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 8px;
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  color: var(--ezClockerBlack);
  background-color: rgb(255 255 255/40%);
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

div.ezClockerHeaderTransparent2015 {
  /* Full CSS3 Compliant Browsers */
  transition: 200ms ease-in-out;
  transform: scale(0.75, 0.75);
  transform-origin: center top;
  width: 100%;
  top: -2px;
  left: -2px;
  padding-left: 4px;
  padding-right: 4px;
  position: fixed;
  background-color: rgb(15 71 119/80%);
  color: var(--ezClockerWhite);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

table.ezClockerHeader2015 {
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  width: 100%;
}

td.ezClockerHeader2015 {
  border-style: none;
  text-align: left;
  vertical-align: middle;
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
}

td.ezclockerHeader2015Right {
  vertical-align: middle;
  text-align: right;
}

img.ezClockerHeader2015 {
  max-width: 250px;
  border-style: none;
  padding: 8px;
  margin: 0;
  vertical-align: middle;
}

img.ezClockerEmployerHeader2015 {
  padding: 2px;
  margin: 0;
  border-style: none;
  max-width: 110px;
  max-height: 40px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

a.ezClockerHeader2015 {
  cursor: pointer;
  text-decoration: none;
  color: var(--ezClockerWhite);
}

.ezClockerMainMenu2015 {
  padding: 4px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-style: solid;
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-top-width: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.ezClockerJobMainMenu {
  padding: 4px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-style: solid;
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-top-width: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.ezClockerNavTabMenu {
  padding: 4px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-style: solid;
  border-color: var(--ezClockerSilver);
  border-width: 1px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

div.ezClockerMainContent2015 {
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  overflow: auto;
}

div.fullPageContent2015 {
  margin: 0;
  background-color: var(--ezClockerWhite);
  padding: 0;
  overflow: auto;
}

.notVisible {
  display: none;
}

/* Job Dashboard Employee Table Styles */
.ezJobEmployeeNameCell {
  text-align: left;
  padding: 4px;
  font-size: 12pt;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border: 1px solid var(--ezClockerBlack);
}

.ezJobEmployeeHoursCell {
  text-align: center;
  padding: 4px;
  font-size: 12pt;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border: 1px solid var(--ezClockerBlack);
}

.ezJobEmployeeTable {
  margin-bottom: 20px;
  border-collapse: collapse;
  font-size: 12pt;
  border: 1px solid var(--ezClockerBlack);
}

.ezJobDateHeader {
  text-align: left;
  padding: 4px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 12pt;
  font-weight: bold;
  border: 1px solid var(--ezClockerBlack);
}

.ezJobColumnHeader {
  text-align: left;
  padding: 4px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border: 1px solid var(--ezClockerBlack);
}

.ezJobColumnHeaderCenter {
  text-align: center;
  padding: 4px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border: 1px solid var(--ezClockerBlack);
}

.ezJobTotalRowEmpty {
  padding: 4px;
  font-size: 12pt;
  background-color: var(--ezClockerWhite);
  border: none;
}

.ezJobTotalRowValue {
  text-align: center;
  padding: 4px;
  font-size: 12pt;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerWhite);
  font-weight: bold;
  border: 1px solid var(--ezClockerBlack);
}

.ezJobDisplayEmployeeHours {
  margin: 20px;
  padding: 20px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezClockerGray);
  height: 500px;
  overflow-y: auto;
}

/* Job Dashboard - Collapsible Month Groups */
.ezJobMonthGroup {
  margin-bottom: 16px;
  border: 2px solid var(--ezClockerNavy);
  border-radius: 4px;
}

.ezJobMonthSummary {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 14px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 13pt;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  list-style: none;
}

.ezJobMonthSummary::-webkit-details-marker {
  display: none;
}

.ezJobMonthArrowClosed,
.ezJobMonthArrowOpen {
  font-size: 10pt;
  min-width: 12px;
}

.ezJobMonthArrowOpen {
  display: none;
}

.ezJobMonthGroup[open] .ezJobMonthArrowClosed {
  display: none;
}

.ezJobMonthGroup[open] .ezJobMonthArrowOpen {
  display: inline;
}

.ezJobMonthSummary:hover {
  opacity: 0.88;
}

.ezJobMonthLabel {
  flex: 1;
}

.ezJobMonthTotalHours {
  font-size: 11pt;
  font-weight: normal;
  opacity: 0.9;
}

.ezJobMonthLaborCost {
  font-size: 11pt;
  font-weight: normal;
  opacity: 0.9;
}

.ezJobMonthContent {
  padding: 12px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ezclocker-page-layout.css"],"names":[],"mappings":"AAAA;;;;iEAAA;AAMA;EACI,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,sCAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,iCAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,gCAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,qBAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,+BAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAAJ;;AAGA;EACI,SAAA;EACA,uCAAA;EACA,UAAA;EACA,cAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA,wCAAA;AACA;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,4BAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,4BAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,YAAA;EACA,eAAA;EACA,uCAAA;EACA,YAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;EACA,aAAA;EACA,gBAAA;AAAJ;;AAGA,6CAAA;AACA;EACI,mBAAA;EACA,sCAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;;EAEI,eAAA;EACA,eAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,OAAA;AAAJ;;AAGA;EACI,eAAA;EACA,mBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,eAAA;EACA,mBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Legacy 2015 Styles\n| If possible, migrate to classes defined in non-legacy css files.\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\ndiv.ezClockerHeader2015 {\n    z-index: 9999;\n    transition: 200ms ease-in-out;\n    transform-origin: center top;\n    transform: none;\n    width: 100%;\n    top: -2px;\n    left: -2px;\n    padding-left: 4px;\n    padding-right: 4px;\n    position: fixed;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n}\n\ndiv.ezClockerHeader2015NonFixed {\n    transition: 200ms ease-in-out;\n    transform-origin: center top;\n    transform: none;\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-bottom: 8px;\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n    color: var(--ezClockerBlack);\n    background-color: rgb(255 255 255 / 40%);\n    border-bottom-color: var(--ezClockerBlack);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\ndiv.ezClockerHeaderTransparent2015 {\n    /* Full CSS3 Compliant Browsers */\n    transition: 200ms ease-in-out;\n    transform: scale(0.75, 0.75);\n    transform-origin: center top;\n    width: 100%;\n    top: -2px;\n    left: -2px;\n    padding-left: 4px;\n    padding-right: 4px;\n    position: fixed;\n    background-color: rgb(15 71 119 / 80%);\n    color: var(--ezClockerWhite);\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\ntable.ezClockerHeader2015 {\n    border-spacing: 0;\n    border-collapse: collapse;\n    padding: 0;\n    width: 100%;\n}\n\ntd.ezClockerHeader2015 {\n    border-style: none;\n    text-align: left;\n    vertical-align: middle;\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n}\n\ntd.ezclockerHeader2015Right {\n    vertical-align: middle;\n    text-align: right;\n}\n\nimg.ezClockerHeader2015 {\n    max-width: 250px;\n    border-style: none;\n    padding: 8px;\n    margin: 0;\n    vertical-align: middle;\n}\n\nimg.ezClockerEmployerHeader2015 {\n    padding: 2px;\n    margin: 0;\n    border-style: none;\n    max-width: 110px;\n    max-height: 40px;\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n}\n\na.ezClockerHeader2015 {\n    cursor: pointer;\n    text-decoration: none;\n    color: var(--ezClockerWhite);\n}\n\n.ezClockerMainMenu2015 {\n    padding: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    border-style: solid;\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-top-width: 0;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n\n.ezClockerJobMainMenu {\n    padding: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    border-style: solid;\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-top-width: 0;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n\n.ezClockerNavTabMenu {\n    padding: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-top: 10px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    border-style: solid;\n    border-color: var(--ezClockerSilver);\n    border-width: 1px;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n\ndiv.ezClockerMainContent2015 {\n    margin-top: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 0;\n    overflow: auto;\n}\n\ndiv.fullPageContent2015 {\n    margin: 0;\n    background-color: var(--ezClockerWhite);\n    padding: 0;\n    overflow: auto;\n}\n\n.notVisible {\n    display: none;\n}\n\n/* Job Dashboard Employee Table Styles */\n.ezJobEmployeeNameCell {\n    text-align: left;\n    padding: 4px;\n    font-size: 12pt;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    border: 1px solid var(--ezClockerBlack);\n}\n\n.ezJobEmployeeHoursCell {\n    text-align: center;\n    padding: 4px;\n    font-size: 12pt;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    border: 1px solid var(--ezClockerBlack);\n}\n\n.ezJobEmployeeTable {\n    margin-bottom: 20px;\n    border-collapse: collapse;\n    font-size: 12pt;\n    border: 1px solid var(--ezClockerBlack);\n}\n\n.ezJobDateHeader {\n    text-align: left;\n    padding: 4px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-size: 12pt;\n    font-weight: bold;\n    border: 1px solid var(--ezClockerBlack);\n}\n\n.ezJobColumnHeader {\n    text-align: left;\n    padding: 4px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n    border: 1px solid var(--ezClockerBlack);\n}\n\n.ezJobColumnHeaderCenter {\n    text-align: center;\n    padding: 4px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n    border: 1px solid var(--ezClockerBlack);\n}\n\n.ezJobTotalRowEmpty {\n    padding: 4px;\n    font-size: 12pt;\n    background-color: var(--ezClockerWhite);\n    border: none;\n}\n\n.ezJobTotalRowValue {\n    text-align: center;\n    padding: 4px;\n    font-size: 12pt;\n    background-color: var(--ezClockerGray);\n    color: var(--ezClockerWhite);\n    font-weight: bold;\n    border: 1px solid var(--ezClockerBlack);\n}\n\n.ezJobDisplayEmployeeHours {\n    margin: 20px;\n    padding: 20px;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezClockerGray);\n    height: 500px;\n    overflow-y: auto;\n}\n\n/* Job Dashboard - Collapsible Month Groups */\n.ezJobMonthGroup {\n    margin-bottom: 16px;\n    border: 2px solid var(--ezClockerNavy);\n    border-radius: 4px;\n}\n\n.ezJobMonthSummary {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 10px 14px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-size: 13pt;\n    font-weight: bold;\n    cursor: pointer;\n    user-select: none;\n    list-style: none;\n}\n\n.ezJobMonthSummary::-webkit-details-marker {\n    display: none;\n}\n\n.ezJobMonthArrowClosed,\n.ezJobMonthArrowOpen {\n    font-size: 10pt;\n    min-width: 12px;\n}\n\n.ezJobMonthArrowOpen {\n    display: none;\n}\n\n.ezJobMonthGroup[open] .ezJobMonthArrowClosed {\n    display: none;\n}\n\n.ezJobMonthGroup[open] .ezJobMonthArrowOpen {\n    display: inline;\n}\n\n.ezJobMonthSummary:hover {\n    opacity: 0.88;\n}\n\n.ezJobMonthLabel {\n    flex: 1;\n}\n\n.ezJobMonthTotalHours {\n    font-size: 11pt;\n    font-weight: normal;\n    opacity: 0.9;\n}\n\n.ezJobMonthLaborCost {\n    font-size: 11pt;\n    font-weight: normal;\n    opacity: 0.9;\n}\n\n.ezJobMonthContent {\n    padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
